import Card from "components/Layout/Card";
import Table from "components/Layout/Table";
import Button from "components/form/Button";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchInviteSpeakers } from "store/slices";
import { getUserType, titleCaseString } from "utils/helpers";

const InvitationsReceived = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [receivedInvitationData, setReceivedInvitationData] = useState({
    loading: true,
    data: [],
  });

  const receivedInvitationList = async () => {
    const response = await dispatch(fetchInviteSpeakers());
    if (response?.status === 200) {
      setReceivedInvitationData((prev) => {
        return {
          ...prev,
          data: response?.data || [],
          loading: false,
        };
      });
    }
  };

  useEffect(() => {
    receivedInvitationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const header = [
    {
      isSearch: false,
      title: "Conference Name",
    },
    {
      isSearch: false,
      title: "Received on",
    },
    {
      isSearch: false,
      title: "Status",
    },
    {
      isSearch: false,
      title: "Action",
    },
  ];

  let rowData = [];
  receivedInvitationData?.data?.forEach((elem) => {
    let obj = [
      {
        value: titleCaseString(elem?.event_name),
      },
      {
        value: elem?.received_on,
      },
      {
        value: elem?.status,
      },
      {
        value: (
          <span className="action-icon-buttons">
            <Button
              onClick={() => {
                const userType = getUserType();
                navigate(
                  `/${userType}/career-support/applied-career-support/keynote-speaker/invitation-received/${elem?.id}`
                );
              }}
              text="View Invitation"
              btnStyle="primary-outline"
              className="text-14-500 mw-115"
              isSquare
            />
          </span>
        ),
      },
    ];
    rowData?.push({ data: obj });
  });

  return (
    <div id="invitation-received-container">
      <Card className="cps-20 cpe-20 cmb-20 cpt-20 cpb-20">
        <div className="overflow-auto">
          <Table
            header={header}
            rowData={rowData}
            // isLoading={true}
            isLoading={receivedInvitationData?.loading}
          />
        </div>
      </Card>
    </div>
  );
};

export default InvitationsReceived;
